import { useContext, useEffect, useState } from 'react';

import { Menu } from 'src/modules/designStudio/constants';
import { Partner } from 'src/modules/designStudio/helpers/Partner';
import {
  usePartner,
  useToolbarDisplaySettings,
} from 'src/modules/designStudio/hooks';
import {
  MacheteBuildingContext,
  Mode,
} from 'src/modules/designStudio/providers';

const DefaultMenuByPartner: Record<Partner, Menu> = {
  [Partner.DEFAULT]: Menu.TEMPLATE,
  [Partner.JAMES_HARDIE]: Menu.TEMPLATE,
  [Partner.MUELLER]: Menu.ROOF,
  [Partner.AMERIPRO]: Menu.TEMPLATE,
  [Partner.HANSONS]: Menu.TEMPLATE,
  [Partner.INFINITY]: Menu.TEMPLATE,
  [Partner.ABC_SEAMLESS]: Menu.TEMPLATE,
  [Partner.PRIDDY]: Menu.TEMPLATE,
  [Partner.PRIDDY_JH]: Menu.TEMPLATE,
  [Partner.WINDOWS_CERTAINTEED]: Menu.TEMPLATE,
  [Partner.WINDOWS_ROYAL]: Menu.TEMPLATE,
};

export const useSetDefaultMenu = ({
  setMenu,
  mode,
}: {
  setMenu: (menu: Menu) => void;
  mode: Mode;
}) => {
  const partner = usePartner();
  const { onlyDisplayToolbarInFullscreen } = useToolbarDisplaySettings();
  const [hasShownDesignMenuOnStartup, setHasShownDesignMenuOnStartup] =
    useState(false);
  const { building } = useContext(MacheteBuildingContext);

  useEffect(() => {
    if (
      mode !== Mode.PREVIEW &&
      mode !== Mode.PRO_VIEW &&
      mode !== Mode.SHARE &&
      building &&
      !onlyDisplayToolbarInFullscreen &&
      !hasShownDesignMenuOnStartup
    ) {
      setMenu(DefaultMenuByPartner[partner]);
      setHasShownDesignMenuOnStartup(true);
    }
  }, [
    mode,
    setMenu,
    building,
    hasShownDesignMenuOnStartup,
    setHasShownDesignMenuOnStartup,
    onlyDisplayToolbarInFullscreen,
    partner,
  ]);
};
